/**
 * Creates a time tracker that measures elapsed time between start and stop.
 * @returns {Object} A modular timer with start and stop methods
 */
export function createTimer() {
    let startTime = null;
    let endTime = null;

    /**
     * Starts or restarts the timer.
     */
    const start = () => {
        startTime = performance.now();
        endTime = null;
    };

    /**
     * Stops the timer and returns the elapsed time in seconds.
     * @returns {number} Elapsed time in whole seconds.
     */
    const stop = () => {
        if (!startTime) {
            return 0; 
        }

        endTime = performance.now();
        const durationSec = Math.floor((endTime - startTime) / 1000);
        return durationSec;
    };

    return { start, stop }; 
}